/**
 * Sign-up verification constants, shared by Login and VerifyEmail.
 */

export const AUTH_CONSTANTS = {
  VERIFICATION_CODE_LENGTH: 6,
  MAX_VERIFICATION_ATTEMPTS: 3,
  VERIFICATION_EXPIRY_MINUTES: 10,

  SESSION_KEYS: {
    VERIFICATION_DATA: 'verificationData',
  },
} as const;
